/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type PaymentTypeMethod = 0 | 1 | 2 | 3 | 4 | 5;

export const PaymentTypeMethod = {
    NUMBER_0: 0 as PaymentTypeMethod,
    NUMBER_1: 1 as PaymentTypeMethod,
    NUMBER_2: 2 as PaymentTypeMethod,
    NUMBER_3: 3 as PaymentTypeMethod,
    NUMBER_4: 4 as PaymentTypeMethod,
    NUMBER_5: 5 as PaymentTypeMethod
}